import React, { useEffect, useState } from "react";
import { Table, Button, Tooltip } from "antd";
import { YHModal } from "@/components/YHModal";
import { YhBox } from "@/components/YhBox";
import { IDescription, DescriptionColorEnum } from "@/components/YhBox/Types";
import { ColumnsType, TablePaginationConfig } from "antd/es/table";
import { DEFAULT_PAGE_SIZE, DEFAULT_FIRST_PAGE_NUM } from "@/utils/constants";
import { ISearchPage } from "@/types/ScmTypes";
import { sourceAppOrBranch } from "@/types/VrmSaDictEnums";
import useGlobalModel from "@/model/globalModel";
import { transPgToPagination, momentFormat } from "@/utils/utils";
import { commonModuleService, ISupperDetail, IUseStatistics, ISupperSearch } from "./commonModuleService"
import { convertRes2Blob } from "@/utils/exportFile";
import YhTootip from "@/components/YhTootip";
interface IConSumeHistoryType {
    visible: boolean,
    name: string,
    onCancel: () => void
}
export const SupplierHistoryModel = ({
    visible,
    name,
    onCancel,
}: IConSumeHistoryType) => {
    const initDesc = {
        amount: 0,
        totalNum: 0,
        inTotal: 0
    }
    const { shopAndOrg } = useGlobalModel(({ shopAndOrg }) => [shopAndOrg]);

    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [dataSource, setDataSource] = useState<ISupperDetail[]>([]);
    const [descTotal, setDescTotal] = useState<IUseStatistics>(initDesc);
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    const [searchParam, setSearchParam] = useState<ISupperSearch>({})

    useEffect(() => {
        if (visible) {
            loadData(initPgCfg, { userName: name })
            setSearchParam({ userName: name })
        }
    }, [visible])

    const loadData = async (page?: ISearchPage, searchValue: ISupperSearch = searchParam) => {
        let searchParams = {
            ...searchValue,
            ...shopAndOrg,
            ...sourceAppOrBranch,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await commonModuleService.supperPage(searchParams);
        const { records, statistics, ...pg } = retData
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
        setDescTotal(statistics)

    }
    const desc: IDescription[] = [
        {
            label: "应收金额",
            value: descTotal.amount,
            color: DescriptionColorEnum.red
        },
    ]
    const columns: ColumnsType<any> = [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            render: (t, r, i) => i + 1
        }, {
            title: '供应商名称',
            width: 120,
            dataIndex: 'userName',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '单据编号',
            width: 120,
            dataIndex: 'tradeCode',
        }, {
            title: '单据类型',
            width: 120,
            dataIndex: 'tradeTypeName',
        }, {
            title: '单据日期',
            width: 120,
            dataIndex: 'createTime',
            render: (text) => momentFormat(text)
        }, {
            title: '应收金额',
            width: 120,
            dataIndex: 'amount',
        }, {
            title: '制单人',
            width: 120,
            dataIndex: 'billingClerk',
        }
    ]
    const onExport = async () => {
        const searchParams = {
            ...searchParam,
            ...shopAndOrg,
        }
        let result = await commonModuleService.stockIoExport(searchParams);
        convertRes2Blob(result)
    }
    const title = <>
        <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={onExport}
        >导出</Button >
    </>
    return <YHModal
        visible={visible}
        onCancel={onCancel}
        title="采购历史"
        width={'70%'}
        bodyHeight={730}
        showFooter={false}
    >
        <YhBox title={title} descriptions={desc}>
            <Table
                bordered
                style={{ cursor: "pointer" }}
                columns={columns}
                dataSource={dataSource}
                pagination={{
                    ...pgCfg,
                    position: ["bottomCenter"],
                    showTotal: () => `共${pgCfg.total}条`,
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize }).then();
                    }
                }}
                scroll={{ x: 'max-content', y: 520 }}
            >
            </Table>
        </YhBox>

    </YHModal>
}